import React from "react";
import { Box } from "@mui/material";
import PlanUpgradeDialogWrapper from "../planUpgradeDialogWrapper/PlanUpgradeDialogWrapper.tsx";
import { usePlanDialogWrapperHooks } from "./planDialogWrapper.hooks.ts";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";

interface IPlanDialogWrapper {
    enabled: boolean;
    children: any;
    text: string;
    hoverText?: string;
    position?:
        | "bottom-end"
        | "bottom-start"
        | "bottom"
        | "left-end"
        | "left-start"
        | "left"
        | "right-end"
        | "right-start"
        | "right"
        | "top-end"
        | "top-start"
        | "top";
}

function PlanDialogWrapper(props: IPlanDialogWrapper) {
    const { showDialog, setShowDialog } = usePlanDialogWrapperHooks();

    return (
        <React.Fragment>
            {props.enabled ? (
                <Box
                    sx={{
                        "&:hover": { cursor: "pointer !important" },
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowDialog(true);
                    }}
                >
                    <DotLegalTooltip position={props.position} text={props.hoverText}>
                        {props.children}
                    </DotLegalTooltip>
                </Box>
            ) : (
                props.children
            )}

            {showDialog && <PlanUpgradeDialogWrapper text={props.text} onDialogClose={() => setShowDialog(false)} />}
        </React.Fragment>
    );
}

export default PlanDialogWrapper;
